import cn from 'classnames';
import Link from 'next/link';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { useRouter } from 'next/router';
import { CampaignWithTeam } from '../../../lib/hooks/campaigns';

type Props = {
  campaign: CampaignWithTeam;
};

function Breadcrumb({ campaign }: Props) {
  const router = useRouter();

  const { teamSlug, campaignSlug } = router.query;

  const subPaths = router.asPath
    .slice(1)
    .split('/')
    .reduce((acc, path) => {
      if (acc.length !== 0) {
        acc.push(`${acc[acc.length - 1]}/${path}`);
      } else {
        acc.push(`/${path}`);
      }

      return acc;
    }, []);

  const getBreadcrumbContent = (path: string, i: number) => {
    const lastPart = path.slice(path.lastIndexOf('/') + 1);

    switch (i) {
      case 0:
        return campaign?.team.name || teamSlug;
      case 1:
        return campaign?.name || campaignSlug;
      case 2:
      case 3:
        return `${lastPart.charAt(0).toUpperCase()}${lastPart.slice(1)}`;
      default:
        return lastPart;
    }
  };

  return (
    <nav className="hidden sm:flex" aria-label="Breadcrumb">
      <ol role="list" className="flex items-center space-x-4">
        {subPaths.map((path, i) => (
          <li key={path}>
            <div className="flex items-center">
              {i !== 0 && (
                <ChevronRightIcon
                  className="flex-shrink-0 h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
              )}
              <Link
                href={path}
                passHref
                {...(i + 1 === subPaths.length && {
                  'aria-current': 'page',
                })}
                className={cn(
                  'text-sm font-medium text-gray-500 hover:text-gray-700',
                  {
                    'ml-4': i !== 0,
                  },
                )}
              >
                {getBreadcrumbContent(path, i)}
              </Link>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}

export default Breadcrumb;
